'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Maybe = require('../fp/Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

require('./EllipsisDisplay.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ellipsisDispalyContent = null;

var EllipsisDisplay = function (_PureComponent) {
  (0, _inherits3.default)(EllipsisDisplay, _PureComponent);

  function EllipsisDisplay() {
    (0, _classCallCheck3.default)(this, EllipsisDisplay);
    return (0, _possibleConstructorReturn3.default)(this, (EllipsisDisplay.__proto__ || (0, _getPrototypeOf2.default)(EllipsisDisplay)).apply(this, arguments));
  }

  (0, _createClass3.default)(EllipsisDisplay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var contentHeight = this.props.contentHeight;

      var detailContent = ellipsisDispalyContent;
      var detailHeight = detailContent && detailContent.clientHeight ? detailContent.clientHeight : 0;
      if (!!detailContent && detailHeight > contentHeight) {
        detailContent.classList.add('ellipsis-display__active');
        detailContent.style.maxHeight = contentHeight + 'px';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var content = this.props.content;

      var className = (0, _Maybe.maybe)('', function (name) {
        return ' ' + name;
      }, _Maybe2.default.of(this.props.className));

      return _react2.default.createElement(
        'div',
        {
          className: 'ellipsis-dispaly__content' + className,
          title: content,
          ref: function ref(e) {
            ellipsisDispalyContent = e;
          } },
        content
      );
    }
  }]);
  return EllipsisDisplay;
}(_react.PureComponent);

EllipsisDisplay.defaultProps = {
  contentHeight: 20
};
exports.default = EllipsisDisplay;